import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-bootstrap/Alert';
import s from './DeviceTile.module.scss';
import bs from '../../styles/bootstrap-overrides.scss';
import pin from '../../assets/location.svg';
import deviceProcessing from '../../assets/device-processing.svg';
import modelImg from '../../assets/model.svg';
import stateImg from '../../assets/state.svg';
import locationImg from '../../assets/locationdot.svg';
import alert from '../../assets/alert.svg';
import warning from '../../assets/warning.svg';
import pendingAlarm from '../../assets/alarm-outline-small.svg';
import online from '../../assets/online.svg';
import { push } from 'redux-first-history';
import offline from '../../assets/offline.svg';
import { FormattedMessage, IntlProvider, useIntl } from 'react-intl';
import moment from 'moment';
import { ALARM_STATUS_NEW, ALARM_STATUS_PENDING } from '../../constants';
import locked from '../../assets/blue-locked.svg';
import schedule from '../../assets/clock-blue.svg';
import Cookies from 'js-cookie';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import languageObject from '../../translations/messages';
import { getSequenceName } from '../../utils';

const DeviceTile = ({
  unitName,
  handleClick,
  location = 'unknown',
  country,
  model,
  unitSerialNumber = '',
  deviceSerialNumber,
  unitId= '',
  isTaggedOut,
  onWarningClick,
  onAlarmClick,
  deviceSensorData,
  deviceEventData,
  deviceAlarmsData,
  flowSequences,
  tagOutMessage,
  isSchedulesCount,
  scheduleMessage,
  ModelCategoryId
}) => {
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;
  const intl = useIntl();
  // Get the message texts into variables
  const warningsText = intl.formatMessage(
    { id: "deviceTile.warnings", defaultMessage: "Warnings in the last 24h" }
  );

  const newAlarmsText = intl.formatMessage(
    { id: "deviceTile.newAlarms", defaultMessage: "New Alarms" }
  );

  const pendingAlarmText = intl.formatMessage(
    { id: "deviceList.pendingAlarm", defaultMessage: "pending alarm" }
  );

  const timestamp = deviceSensorData && deviceSensorData.map(item => item.timestamp);
  const deviceOnline = timestamp && timestamp[0] && moment(timestamp[0]).isBetween(moment().subtract(2, 'minute'), moment());
  let currentSequence = 'Data is not available';
  let currentSequenceObj = deviceSensorData && deviceSensorData.map(item => item.current_state);
  if (currentSequenceObj && currentSequenceObj.length > 0) {
    let sequence = getSequenceName(flowSequences, currentSequenceObj[0]);
    currentSequence = sequence.Name != '' ? sequence.Name : 'Data is not available';
  }
  // const deviceEvent =
  //   deviceEventData && deviceEventData.length > 0 && deviceEventData[0].events && deviceEventData[0].events.filter(item => item.type === 0);
  // const flowSequence =
  //   deviceEvent &&
  //   deviceEvent[0] &&
  //   deviceEvent[0].code &&
  //   flowSequences &&
  //   flowSequences.filter(x => x.SequenceCode === parseInt(deviceEvent[0].code));
  // const currentSequence = flowSequence && flowSequence.length > 0 && flowSequence[0].Name;

  const warnings =
    deviceEventData && deviceEventData.length > 0 && deviceEventData[0].events && deviceEventData[0].events.filter(item => item.type === 1);

  const newAlarms =
    deviceAlarmsData &&
    deviceAlarmsData.filter(event => {
      return event.EventStatus === ALARM_STATUS_NEW;
    });

  const pendingAlarms =
    deviceAlarmsData &&
    deviceAlarmsData.filter(event => {
      return event.EventStatus === ALARM_STATUS_PENDING;
    });

  let warningCount = (warnings && warnings.length) || 0;
  let newAlarmsCount = (newAlarms && newAlarms.length) || 0;
  let pendingAlarmsCount = (pendingAlarms && pendingAlarms.length) || 0;

  const eventTypeClass = newAlarmsCount > 0 || pendingAlarmsCount > 0 ? s.error : warningCount > 0 ? s.warning : '';
  const locale = Cookies.get(`defaultLanguage-${envName}`) || 'en';

  return (
    <IntlProvider locale={locale} messages={languageObject[locale]}>
      <div key={unitSerialNumber} className={`${s.deviceTile} ${eventTypeClass}`}>
        <a
          onClick={() => {
            handleClick(unitSerialNumber);
          }}

        >
          <div className={s.contentWrapper}>
            <div className={s.rightContainer}>
              {isSchedulesCount ? (
                <div className={s.scheduleIcon}>
                  <img src={schedule} data-tooltip-content={scheduleMessage} data-tooltip-id={`tooltip-schedule-${unitSerialNumber}`} />
                  <Tooltip id={`tooltip-schedule-${unitSerialNumber}`} />
                </div>
              ) : (
                ''
              )}

              {isTaggedOut ? (
                <div className={s.taggedout}>
                  <img src={locked} data-tooltip-content={tagOutMessage} data-tooltip-id={`tooltip-tagout-${unitSerialNumber}`} />
                  <Tooltip id={`tooltip-tagout-${unitSerialNumber}`} />
                </div>
              ) : (
                ''
              )}
            </div>

            <div className={s.deviceName}>{unitName}</div>
            <div className={s.deviceId}>
              {unitSerialNumber}, {deviceSerialNumber}
            </div>
            <div className={s.deviceInfo}>
              {model && (
                <div className={s.infoItem}>
                  <div className={s.infoIcon}><img src={modelImg} /></div>
                  {model ? model : '-'}
                </div>
              )}
              <div className={s.infoItem}>
                <div className={s.infoIcon}><img src={locationImg} /></div>
                <span>{`${location}, ${country}`}</span>
              </div>
              <div className={s.infoItem}>
                <div className={s.infoIcon}><img src={stateImg} /></div>
                <div className={`${s.statusBadge} ${s.tagout}`}>{currentSequence ? currentSequence : 'Data not available'}</div>

              </div>
            </div>
            <div className={`${s.statusBadge} ${deviceOnline ? s.online : s.offline}`}> {deviceOnline ? '✅' : '⚠️'}   {deviceOnline ? (
              <FormattedMessage id="deviceTile.online" defaultMessage="Online" />
            ) : (
              <FormattedMessage id="deviceTile.offline" defaultMessage="Offline" />
            )}
            </div>

            <div className={s.indicatorContainer}>

              {pendingAlarmsCount > 0 && (
                <>
                  <div onClick={(e) => {
                    e.stopPropagation();
                    onAlarmClick(ModelCategoryId, unitId, ALARM_STATUS_PENDING);
                  }} className={`${s.indicator} ${s.pendingIndicator} `} data-tooltip-content={pendingAlarmText} data-tooltip-id={`tooltip-pending-alarm-${unitSerialNumber}`} >
                    <span className={s.alarmIcon}>
                      <img src={pendingAlarm} alt="icon" />

                    </span>
                    {pendingAlarms.length}
                  </div>
                  <Tooltip id={`tooltip-pending-alarm-${unitSerialNumber}`} />
                </>
              )}
              {(newAlarmsCount > 0 && (
                <>
                  <div onClick={(e) => {
                    e.stopPropagation();
                    onAlarmClick(ModelCategoryId, unitId, ALARM_STATUS_NEW);
                  }} className={`${s.indicator} ${s.alarmIndicator}`} data-tooltip-content={newAlarmsText} data-tooltip-id={`tooltip-new-alarm-${unitSerialNumber}`}>
                    <span className={s.alarmIcon}> <img src={alert} alt="icon" /></span>
                    ({newAlarms.length})
                  </div>
                  <Tooltip id={`tooltip-new-alarm-${unitSerialNumber}`} />
                </>
              )) || <span />}

              {(warningCount > 0 && (
                <>
                  <div onClick={(e) => {
                    e.stopPropagation();
                    onWarningClick(unitSerialNumber);
                  }} data-tooltip-content={warningsText} data-tooltip-id={`tooltip-warning-${unitSerialNumber}`}>

                    <div className={`${s.indicator} ${s.warningIndicator}`}>
                      <span className={s.alarmIcon}><img src={warning} alt="icon" /></span>
                      ({warnings.length})
                    </div>
                  </div>
                  <Tooltip id={`tooltip-warning-${unitSerialNumber}`} />
                </>

              )) || <span />}
            </div>
          </div>
        </a>
      </div>
    </IntlProvider>
  );
};

DeviceTile.propTypes = {
  unitSerialNumber: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  location: PropTypes.string,
  deviceAlarmsData: PropTypes.array,
  flowSequences: PropTypes.array.isRequired,
  isSchedulesCount: PropTypes.bool
};

export default DeviceTile;
